
import { Vue, Component, Prop } from "vue-property-decorator";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
import LocationIcon from "@/components/icons/LocationIcon.vue";
import UiButton from "@/components/button/ui-button.vue";
import CardInfoChip from "@/components/card/CardInfoChip.vue";
import CreateGroupConversationModal from "@/components/inbox/CreateGroupConversationModal.vue";
import GroupConversationProvider from "@/components/teams/GroupConversationProvider.vue";
import Roles from "@/entities/Roles";
import { Contractor, Manager } from "@/generated/graphql";

@Component({
  components: {
    GroupConversationProvider,
    CreateGroupConversationModal,
    PageHeadIcon,
    PageHeadContainer,
    LocationIcon,
    UiButton,
    CardInfoChip,
  },
})
export default class GroupHeader extends Vue {
  @Prop({type: String, required: true}) readonly currentUserId!: string;
  @Prop({type: String, required: true}) readonly companyId!: string;
  @Prop({ type: String, required: true }) readonly currentUserRole!: Roles;
  @Prop({type: String, required: true}) readonly groupName!: string;
  @Prop({type: String, default: undefined}) readonly groupLocation!: string;
  @Prop({type: Boolean, default: false}) readonly archived!: string;
  @Prop({ type: Array, default: () => [] }) readonly contractors!: Contractor[];
  @Prop({ type: Array, default: () => [] }) readonly managers!: Manager[];

  conversationModalShown: boolean = false;

}
